import React from "react";
import CardClass from "../../../CardClass";
import Table from "../../../Table";
import PropTypes from "prop-types";
import { withRouter } from 'react-router-dom';
import MainContext from "../../../../Context/MainContext/MainContext";

export default withRouter(class CardAdminDistributionReasonList extends CardClass {
    static contextType = MainContext; // For legacy class components

    /**
     * Renders the content of the card.
     */
    renderContent() {
        return (
            <Table
                search={true}
                columns={[
                    { key: "id", name: "ID", type: "number", width: 100 },
                    { key: "code", name: "Code", type: "string", width: 100 },
                    { key: "description", name: "Description", type: "string" },
                ]}
                sort={[
                    {
                        key: "id",
                        direction: "ascending",
                        type: "number"
                    }
                ]}
                rows={Object.values(this.context.distributionReasonsIndexed)}
                onClick={(distributionReason) => {
                    this.props.history.push({
                        pathname: "/admin/distributionReason/" + distributionReason.id
                    });
                }}
            />
        );
    }
});